import { Component, HostListener, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  ListConfig,
  TableColumnConfig,
  TableConfig,
} from '@app/models/shared.model';

@Component({selector: 'app-editable-table-cell',
  templateUrl: './editable-table-cell.component.html',
  styleUrls: ['./editable-table-cell.component.scss'],
  standalone: false,
})
export class EditableTableCellComponent {
  /** Table config */
  @Input() tableConfig: TableConfig;

  /** Table row */
  @Input() row: any;

  /** Current column config */
  @Input() col: TableColumnConfig;

  /** Row index */
  @Input() index: number;

  /** The form group using when we want binding cell with form  */
  @Input() form: FormGroup;

  /** The form control name using when we want binding cell with form  */
  @Input() formControlNameInput: string;

  get listConfigData() {
    const listConfig: ListConfig = this.col.editableConfig!.listConfig!;
    if (this.col?.editableConfig?.listConfigRowsData?.length) {
      listConfig.data = this.col.editableConfig!.listConfigRowsData[this.index] as unknown[];
    } else listConfig.data = this.col.editableConfig!.listConfig!.data;
    return listConfig;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Check if the key pressed is an arrow key
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight')
      event?.stopPropagation();
  }
}
